import React, { useState, useEffect } from "react";
import "./SettingsStyles.css";
import { Link, useNavigate } from "react-router-dom";

import FAQ from "../resources/FAQ";
import HelpfulMaterials from "../resources/HelpfulMaterials";
import QuickHelp from "../resources/QuickHelp";
import NotFoundPage from "../404/NotFound";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import DefaultAssessment from "./DefaultAssessment";
import { useSelector } from "react-redux";
const SidePillItem = ({ text, isActive }) => {
  return (
    <div
      className={`sidepill-item${isActive ? "-active" : ""}`}
      style={{ width: "100%", display: "block" }}
    >
      {text}
    </div>
  );
};
const SwitcherLayout = (props) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.app);
  const [isActive, setIsActive] = useState(1);

  const pathLookup = {
    "": 1,
    faq: 2,
    profile: 3,
    helpful: 4,
    "quick-help": 5,
    "change-password": 6,
    "default-assessment": 7,
  };

  useEffect(() => {
    let path = window.location.pathname.split("/settings/");
    if (path?.length > 0) {
      path = path[1]?.replaceAll("/", "");
    }

    if (!(path in pathLookup)) {
      navigate("/settings/");
    } else {
      setIsActive(pathLookup[path]);
    }
  }, []);

  const componentLookup = {
    1: <Profile {...props} />,
    2: <FAQ {...props} />,
    3: <Profile {...props} />,
    4: <HelpfulMaterials {...props} />,
    5: <QuickHelp {...props} />,
    6: <ChangePassword {...props} />,
    7: <DefaultAssessment {...props} />,
  };

  return (
    <section id="switcher">
      <div
        className="container-fluid row"
        style={{ margin: "0px", padding: "0px" }}
      >
        {user?.role === "INVOICING_ADMIN" ? (
          <div className="col-sm-12 col-md-2 col-lg-2">
            <Link
              to="/settings/change-password"
              replace
              onClick={() => {
                setIsActive(6);
              }}
            >
              <SidePillItem
                text={"Change Password"}
                isActive={isActive === 6}
              />
            </Link>
          </div>
        ) : (
          <div className="col-sm-12 col-md-2 col-lg-2">
            <Link
              to="/settings/profile"
              replace
              onClick={() => {
                setIsActive(1);
              }}
            >
              <SidePillItem text={"Profile"} isActive={isActive === 1} />
            </Link>
            <Link
              to="/settings/change-password"
              replace
              onClick={() => {
                setIsActive(6);
              }}
            >
              <SidePillItem
                text={"Change Password"}
                isActive={isActive === 6}
              />
            </Link>
            <Link
              to="/settings/default-assessment"
              replace
              onClick={() => {
                setIsActive(7);
              }}
            >
              <SidePillItem
                text={"Default Assessment"}
                isActive={isActive === 7}
              />
            </Link>
          </div>
        )}

        <div className="col-sm-12 col-md-10 col-lg-10">
          {componentLookup[isActive] || <NotFoundPage />}
        </div>
      </div>
    </section>
  );
};

export default SwitcherLayout;
